// @ts-nocheck
import React from 'react'
import Modal from '@material-ui/core/Modal'
import { observer } from "mobx-react"

import { useStores } from 'hooks/useStores'
import StoresDialogBoxContent from './StoresDialogBoxContent'

const StoresDialogBox = () => {
	const { addressManagerV2Store } = useStores()

	return (
		<Modal open={addressManagerV2Store.loading || addressManagerV2Store.addressPopup?.open || false} disableAutoFocus disableEnforceFocus>
			<StoresDialogBoxContent />
		</Modal>
	)
}


export default observer(StoresDialogBox) as () => React.ReactNode
